<base-index-page
    [config]="baseIndexPageConfig"
    [service]="fileManagerAuditService"
    [idKey]="'auditId'"
></base-index-page>
